/* eslint-disable react/no-unknown-property */
import cx from "classnames";
import "./CompanyBubble.scss";

import setting from "../../assets/images/settingsWhite.svg";
import { Button, Line, Switch, Typography } from "../../ui";
import { BudgetManagement } from "../../widgets";
import { memo, useEffect, useState } from "react";
import { Catalogs } from "../Catalogs";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { setEditCampaign, getCampaigns } from "../../redux/createNewCompany/actions";
import { useNavigate } from "react-router-dom";
import { getIsEmptyObject } from "./common/helperFunctions";
import { Tooltip } from "@mui/material";
// import useStatistics from "../../data/useStatistics";
import useUser from "../../data/useUser";
import useAdminUser from "../../data/useAdminUser";
import React from "react";
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { client } from "../../utils/network";
import { useSnackbar } from "notistack";
import { DOMAIN_API_HOST, getDomainConfig } from "../../configs/main";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

const CompanyBubble = ({ campaignsList, dailyStatsMap, ...campaign }) => {
  const {
    basic_config,
    id,
    status,
    media_plan,
    broadcast_status,
    optimization,
    new_segment_id,
    issues,
    dmp_status
  } = campaign;

  const userData = useUser()
  const adminData = useAdminUser()
  const STATUS_TOGGLE_LOCKED_USER_ID = "1842197c-1980-48c9-8d53-13647ac74384";
  const isStatusToggleLockedClient = userData.user?.id === STATUS_TOGGLE_LOCKED_USER_ID;
  const isSuperuserInLockedCabinet = isStatusToggleLockedClient && adminData.role === "SUPERUSER";
  const isCampaignToggleLocked = isStatusToggleLockedClient && !isSuperuserInLockedCabinet;
  const RESTRICTED_CLIENT_ID = "d13b7ea6-4c0b-43f6-905f-6780abda0f96";
  const EXTRA_RESTRICTED_CLIENT_ID = "7d828c81-bb08-4f50-9882-c33e56006b87";
  const NO_SETTINGS_CLIENT_ID = "d7de6dcb-228b-479b-9226-855853edc9e5";
  const isRestrictedUser = ([RESTRICTED_CLIENT_ID, EXTRA_RESTRICTED_CLIENT_ID, NO_SETTINGS_CLIENT_ID, "eab9761d-5e15-4212-b09b-50bbc86ed90c", "6d485413-ee24-4963-9f74-51feb24f761c", "c6ecfcdf-9fd6-4a31-8aea-1bc112a8b15e"].includes(userData.user.id) || Boolean(userData.user?.cabinet_visibility?.hide_campaign_settings)) && !["ADMIN", "MANAGER", "SUPERUSER"].some((el) => adminData.role === el);
  const isExtraRestrictedUser = userData.user.id === EXTRA_RESTRICTED_CLIENT_ID && !["ADMIN", "MANAGER", "SUPERUSER"].some((el) => adminData.role === el);

  const { enqueueSnackbar } = useSnackbar();
  const [new_status, setNewStatus] = useState(status);
  // const [visibleGraph, setVisibleGraph] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const toggleVisibleGraph = () => {
  //   setVisibleGraph(!visibleGraph);
  // };
  // console.log(id,issues)
  const [isCardShown, setIsShown] = useState(true);

  const handleMouseOver = () => {
    setIsShown(false);
  };

  const handleMouseOut = () => {
    setIsShown(true);
  };
  // const buttonVariant = useMemo(() => {
  //   switch (new_status) {
  //     case "BLOCKED": {
  //       return "error";
  //     }
  //     case "NOTCOMPLETE": {
  //       return "dark";
  //     }
  //     default:
  //       return "gradient";
  //   }
  // }, [new_status]);
  // console.log(broadcast_status, status)
  // eslint-disable-next-line no-unused-vars
  const [isBroadcast, setIsBroadcast] = useState(
    broadcast_status === "DELIVERING"
  );
  // const [isActive, setIsActive] = useState(status === "ACTIVE");
  const { name } = basic_config;
  const notComplete =
    getIsEmptyObject(basic_config) ||
    getIsEmptyObject(new_segment_id) ||
    getIsEmptyObject(media_plan) ||
    getIsEmptyObject(optimization);
  let statusCompany = !["a31f137c-94b7-4f2c-a686-83d3fa7b59e4", "797a4b73-5698-4aa4-bd85-d29956e1d157"].includes(userData.user.id) ? broadcast_status : "DELIVERING"
  if (status === new_status) { if (status === "BLOCKED" || status === "DELETED") statusCompany = "NO_ACTIVE" }
  else if (new_status === "BLOCKED" || new_status === "DELETED") statusCompany = "NO_ACTIVE"
  // isActive && isBroadcast && !notComplete
  //   ? "ACTIVE"
  //   : !isActive || notComplete
  //   ? "NOTCOMPLETE"
  //   : "MODERATING";

  //const Auditory = segmentNormalizer(auditory);
  const segments = useSelector((state) => state.segments.segments);
  function SegmentSearch(new_segment_id) {
    const selected = segments.filter((segment) => new_segment_id === segment.id);
    //console.log(new_segment_id)
    //console.log(selected[0])
    return (selected[0])
  }
  // const {StatIdDay} = useAnalyzeIdDay(id);
  // const { avg, full_budget, daily_budget } = campaign_stat.budget;
  // const metricCounter = basic_config?.ya_metrika_counter_id;
  // const yesterday = new Date();
  // yesterday.setDate(yesterday.getDate() - 1);
  // const { data: yesterdayStats } = useStatistics(
  //   metricCounter,
  //   yesterday,
  //   yesterday,
  //   [id],
  //   [],
  //   "day",
  //   [],
  //   "campaigns"
  // );
  // const yesterdayTotals = yesterdayStats?.totals || [];
  const yesterdayStats = dailyStatsMap?.[id] || dailyStatsMap?.[String(id)] || [];
  const showsYesterday = Number(yesterdayStats?.[0] ?? 0);
  const clicksYesterday = Number(yesterdayStats?.[1] ?? 0);
  const ctrYesterday = Number(yesterdayStats?.[3] ?? 0);
  const cpcYesterday = Number(yesterdayStats?.[4] ?? 0);
  const ecpmYesterday = Number(yesterdayStats?.[5] ?? 0);
  const isClicksTarget = optimization?.optimization_target === "CLICKS";
  const [checked, setChecked] = useState((status === 'ACTIVE') ? true : false);
  const getDaysWord = (count) => {
    if ([11, 12, 13, 14].includes(count % 100)) {
      return "дней";
    }
    if (count % 10 === 1) {
      return "день";
    }
    if ([2, 3, 4].includes(count % 10)) {
      return "дня";
    }
    return "дней";
  };
  const calculateDaysBetween = (dateStart, dateEnd) => {
    if (!dateStart || !dateEnd) return 0;
    const start = new Date(dateStart);
    const end = new Date(dateEnd);
    const timeDiff = end.getTime() - start.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
  };

  const isRetargeo = userData.user.signup_domain === 'lk.retargeo.ru';
  const totalBudget = (() => {
    if (isRetargeo && media_plan?.date_start && media_plan?.date_end) {
      const daysCount = calculateDaysBetween(media_plan.date_start, media_plan.date_end);
      return basic_config.daily_budget * daysCount;
    }
    return basic_config.full_budget;
  })();

  const handleChangeStatus = async () => {
    if (isCampaignToggleLocked) return;

    const isTurningOn = new_status === 'BLOCKED';
    const adminToken = isSuperuserInLockedCabinet ? localStorage.getItem("admin_token") : null;
    const adminHeaders = adminToken ? { "X-Admin-Token": adminToken } : {};

    if (!isSuperuserInLockedCabinet && isTurningOn && userData.user.user_balance.score <= 0) {
      enqueueSnackbar("Недостаточно средств для запуска кампании", { variant: "error" })
      return
    }

    if (!isSuperuserInLockedCabinet && isTurningOn) {
      const today = new Date();
      const endDate = new Date(media_plan?.date_end);

      if (!media_plan?.date_end || endDate <= today) {
        return enqueueSnackbar("Дата окончания медиаплана должна быть больше сегодняшней даты", { variant: "error" })
      }
    }

    if (!isSuperuserInLockedCabinet && isTurningOn && (getDomainConfig().brand === "retargeo" || getDomainConfig().title === "Programmatic Beta")) {
      if (userData.user.user_balance.score < basic_config.daily_budget) {
        return enqueueSnackbar("Недостаточно средств для запуска кампании с текущим дневным бюджетом", { variant: "error" })
      }

      const activeCampaignsDailyBudget = campaignsList
        .filter(campaign => campaign.status === 'ACTIVE' && campaign.id !== id)
        .reduce((total, campaign) => total + (campaign.basic_config?.daily_budget || 0), 0);

      const totalRequiredDailyBudget = activeCampaignsDailyBudget + basic_config.daily_budget;

      if (userData.user.user_balance.score < totalRequiredDailyBudget) {
        return enqueueSnackbar(`Недостаточно средств для запуска кампании. Общий дневной бюджет всех активных кампаний (${activeCampaignsDailyBudget}р) + текущей кампании (${basic_config.daily_budget}р) = ${totalRequiredDailyBudget}р превышает ваш баланс (${userData.user.user_balance.score}р)`, { variant: "error", autoHideDuration: 7000 })
      }
    }

    if (new_status === 'ACTIVE') {
      enqueueSnackbar("Кампания остановлена", { variant: "info" })

      client.patch(`/api/v1/campaigns/${id}`, {
        "status": "BLOCKED"
      }, { headers: adminHeaders });
      setNewStatus("BLOCKED")
      setChecked(false)
    } else if (new_status === 'BLOCKED') {
      if (isSuperuserInLockedCabinet) {
        enqueueSnackbar("Кампания запущена", { variant: "success" })
      } else {
        const daysAvailable = Math.floor(userData.user.user_balance.score / basic_config.daily_budget);
        enqueueSnackbar(`Кампания запущена! Текущего бюджета хватит на ${daysAvailable} ${getDaysWord(daysAvailable)}`, { variant: "success" })
      }

      const res = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          ...adminHeaders,
        },
        body: JSON.stringify({
          "status": "ACTIVE"
        })
      });
      const data = await res.json()
      if (res.status !== 200) {
        if (!isStatusToggleLockedClient) {
          enqueueSnackbar(data.detail, { variant: "error" })
        }
        return
      }
      setNewStatus("ACTIVE")
      setChecked(true)
    }
  };
  function masissue(issues) {
    let Issues = []
    for (let i = 0; i < issues.length; i++) {
      if (issues?.includes("Свяжитесь с поддержкой.")) return <p>Кампания проходит модерацию.</p>
      Issues.push(<p>{`${issues[i]}`}</p>)
    }
    return Issues
  }
  function masissue2(issues) {
    let Issues = []
    for (let i = 0; i < issues.length; i++) {
      if (issues?.includes("Свяжитесь с поддержкой.")) return <p>Кампания проходит модерацию.</p>
      Issues.push(<p>{`${issues[i].substr(0, 28)}`}...</p>)
      break;
    }
    return Issues
  }
  const handleEdit = () => {
    dispatch(setEditCampaign(id));
    navigate("/add-company");
  };
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const handleDelete = () => {
  //   client.delete(`/api/v1/campaigns/${id}`);
  //   handleClose();
  //   window.location.reload(5);
  // }

  const handleArchive = () => {
    client
      .patch(`/api/v1/campaigns/archive/${id}`)
      .then(() => {
        setNewStatus("BLOCKED");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Ошибка при архивации:", error);
      });
    handleClose();
  }

  const handleUnArchive = () => {
    client
      .patch(`/api/v1/campaigns/unarchive/${id}`)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Ошибка при разархивации:", error);
      });
    handleClose();
  }

  const handleDuplicate = () => {
    client.post(`/api/v1/campaigns/duplicate/${id}`).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar("Кампания продублирована", { variant: "success" })
        window.location.reload(5);
      }
    });
  }

  const handleSelect = () => {
    navigate('/statistics', {
      state: {
        campaign_id: id,
        counter_id: basic_config?.ya_metrika_counter_id
      }
    });
  };

  const campaignSwitch = (
    <Switch
      checked={checked}
      disabled={isCampaignToggleLocked}
      onChange={isCampaignToggleLocked ? undefined : handleChangeStatus}
      inputprops={{ 'aria-label': 'controlled' }}
      value={new_status === 'ACTIVE'}
    />
  );

  function numberWithSpaces(number) {
    if (number < 10000) return number
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return (
    <div className="CompanyBubble">
      <div className={clsx("Card", issues?.includes("Свяжитесь с поддержкой.") && checked ? "PENDING" : statusCompany)} style={{}}>
        <div className="content">
          <button
            type="button"
            className={cx("settingsButton", issues?.includes("Свяжитесь с поддержкой.") && checked ? "PENDING" : statusCompany)}
            disabled={isRestrictedUser}
            onClick={() => !isRestrictedUser && setAnchorEl(!anchorEl)}
          >
            {!isRestrictedUser && (
              <div className="settingsButton_icon">
                <img src={setting} alt="setting" />
              </div>
            )}
            {anchorEl ?
              <Card sx={(window.outerWidth > 1000) ? { width: "140px", borderRadius: "15px", padding: "7px", marginLeft: "40px" }
                : (window.outerWidth < 375) ? { position: "absolute", borderRadius: "15px", top: "0px", left: "0px", width: "140px", padding: "7px", marginTop: "30px", marginLeft: "137px" }
                  : (window.outerWidth < 768) ? { position: "absolute", borderRadius: "10px", top: "0px", left: "0px", width: "140px", padding: "7px", marginTop: "30px", marginLeft: "177px" }
                    : { position: "absolute", borderRadius: "10px", top: "0px", left: "0px", width: "140px", padding: "7px", marginTop: "30px", marginLeft: "537px" }}>
                {/* , height: "90px" borderRadius: "15px" display: 'flex', flexDirection: 'column', 
                 style={{ marginTop: "10px"}}*/}
                {(status !== "DELETED") ? <Button variant="text" style={{ marginTop: "5px" }} onClick={handleEdit} >
                  <Typography variant="h5" color="dark-gray">
                    Редактировать
                  </Typography>
                </Button> : ""}
                <Button variant="text" style={{ marginTop: "5px" }} onClick={handleDuplicate} >
                  <Typography variant="h5" color="dark-gray">
                    Дублировать
                  </Typography>
                </Button>
                {(status !== "DELETED") ? <Button variant="text" style={{ marginTop: "5px" }} onClick={handleClickOpen} >
                  <Typography variant="h5" color="dark-gray">
                    Архивировать
                  </Typography>
                </Button> :
                  <Button variant="text" style={{ marginTop: "5px", marginLeft: "-10px" }} onClick={handleUnArchive} >
                    <Typography variant="h5" color="dark-gray">
                      Разархивировать
                    </Typography>
                  </Button>}
                {/* <Link style={{ marginTop: "20px"}} to="/delete" href="#common-examples" 
                  //component="button" onClick={console.log("delete")}
                   // ...process something
                  //}}
                  > */}
                {/* <div>
                  <Button variant="text" style={{ marginTop: "5px" }} onClick={handleClickOpen} >
                    <Typography variant="h5" color="dark-gray">
                      Удалить
                    </Typography>
                  </Button>
                  </div> */}
              </Card> : ""}
            {/* <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      {"Удаление кампании"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Удалить кампанию?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose}>Нет</Button>
                      <Button onClick={handleDelete} autoFocus>
                        Да
                      </Button>
                    </DialogActions>
                  </Dialog> */}
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Архивация кампании"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Архивировать кампанию {name}?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ gap: 10 }}>
                <Button onClick={handleClose}>Нет</Button>
                <Button onClick={handleArchive} autoFocus>
                  Да
                </Button>
              </DialogActions>
            </Dialog>
          </button>
          {/* {(window.outerWidth < 1000) && (new_status !== "BLOCKED") && <div className="padding"></div>} */}
          <div className="column">
            <div className="client" style={{ marginRight: "10px" }}>
              <Typography variant="h2" color="dark-gray">
                {(name.length > 34) ? name.substr(0, 33) + "..." : name}
              </Typography>
              {window.outerWidth > 768 && (
                <p style={{ display: "flex", alignItems: "center", gap: "5px", textAlign: "center", textWrap: "nowrap", fontSize: "12px", color: "#9a9a9a", margin: "0 10px" }}>
                  {"id " + id.slice(0, 5)}
                </p>
              )}

              {!["a31f137c-94b7-4f2c-a686-83d3fa7b59e4", "797a4b73-5698-4aa4-bd85-d29956e1d157", "d7de6dcb-228b-479b-9226-855853edc9e5"].includes(userData.user.id) ? (

                (window.outerWidth) > 768 &&
                  (new_status !== "BLOCKED" && new_status !== "DELETED") ? <Tooltip
                    title={!isBroadcast ?
                      (notComplete
                        ? issues
                        : !isBroadcast
                          ? ((issues?.length > 1) ? masissue(issues) : issues?.includes("Свяжитесь с поддержкой.") ? ['Кампания проходит модерацию.'] : issues?.length ? issues : ['Кампания проходит модерацию.'])
                          : "") : ''
                    }
                    onClose={handleMouseOut}
                    onOpen={handleMouseOver}
                    open={!isCardShown}
                  //placement="right"
                  >

                  <div sx={{ align: "center" }} style={{ position: "relative" }}>

                    {!isBroadcast ?
                      <Card sx={{
                        height: "15px", position: "absolute", marginLeft: "-60px", marginBottom: "5px", marginTop: "-25px", backgroundColor: "#6d6d6d",
                        whiteSpace: "nowrap", fontSize: "10px", padding: "2px", color: "#ffffff"
                      }} style={!isCardShown ? { opacity: "0" } : {}}>
                        { // className="bg-neutral-500 w-40 h-15"  , marginLeft: "-50%"
                          notComplete
                            ? (<div>{issues}</div>)
                            : !isBroadcast
                              ? ((issues?.length > 1) ? <div>{masissue2(issues)}</div> :
                                <div>{String(issues?.includes("Свяжитесь с поддержкой.") ? ['Кампания проходит модерацию.'] : issues?.length ? issues : ['Кампания проходит модерацию.']).slice(0, 28)}</div>)
                              : ""
                        }
                      </Card> : ""}
                    {campaignSwitch}
                  </div>
                </Tooltip> :
                  campaignSwitch
              ) : (
                campaignSwitch
              )}
            </div>
            <div className="category">
              <Catalogs segment={SegmentSearch(new_segment_id)} />
            </div>
          </div>
          <Line />
          <div className="metrics">
            {!isExtraRestrictedUser && (
              <>
              <div className="column">
                <Typography className="title" variant="h2" color="dark-gray">
                  БЮДЖЕТ И УПРАВЛЕНИЕ
                </Typography>
                <div className="items">
                  {/* <BudgetManagement
                  management="Avg. CPC"
                  budget={avg || 0 + " ₽"}
                /> */}
                  <BudgetManagement
                    management="Дневной Бюджет"
                    budget={numberWithSpaces(basic_config.daily_budget) || 0 + " ₽"}
                  />
                  <BudgetManagement
                    management="Общий Бюджет"
                    budget={numberWithSpaces(totalBudget) || 0 + " ₽"}
                  />
                </div>
              </div>
              <Line />
              </>
            )}
            

            {!["a31f137c-94b7-4f2c-a686-83d3fa7b59e4", "797a4b73-5698-4aa4-bd85-d29956e1d157", "a1856853-7f15-427a-ad58-3c86aca153de", "6d485413-ee24-4963-9f74-51feb24f761c", "69ef6900-94e1-4e07-823a-4ca2658358ec", "c6ecfcdf-9fd6-4a31-8aea-1bc112a8b15e"].includes(userData.user.id) ? (
              <div className="column">
                {window.outerWidth > 768 && (
                  <>
                    <Typography className="title" variant="h2" color="dark-gray">
                      СТАТИСТИКА ЗА ВЧЕРА
                    </Typography>
                    <div className="items2">
                      <BudgetManagement
                        className="statistics"
                        management="Показы"
                        budget={showsYesterday || "0"}
                      />
                      <BudgetManagement
                        className="statistics"
                        management="Клики"
                        budget={clicksYesterday || "0"}
                      />
                      <BudgetManagement
                        className="statistics"
                        management="CTR , %"
                        budget={ctrYesterday ? Number(ctrYesterday).toFixed(2) : "0.00"}
                      />
                      <BudgetManagement
                        className="statistics"
                        management={isClicksTarget ? "CPC , ₽" : "eCPM , ₽"}
                        budget={isClicksTarget
                          ? (cpcYesterday ? Number(cpcYesterday).toFixed(2) : "0.00")
                          : (ecpmYesterday ? Number(ecpmYesterday).toFixed(2) : "0.00")}
                      />
                    </div></>
                )}
                <div className="button">
                  <Button variant="gradient" onClick={handleSelect}>Подробная статистика</Button>
                </div>
              </div>
            ) : (
              <div className="column" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="button">
                  <Button variant="gradient" onClick={handleSelect}>Подробная статистика</Button>
                </div>
              </div>
            )}
          </div>
        </div>
        {window.outerWidth > 768 ? (
          <div style={{ paddingLeft: 50, paddingBottom: 10 }}>
            {/* DMP Pixel Status Block START */}
            <DmpPixelStatus campaignId={id} dmpStatus={dmp_status} />
            {/* DMP Pixel Status Block END */}
          </div>
        ) : (
          <div>
            {/* DMP Pixel Status Block START */}
            <DmpPixelStatus campaignId={id} dmpStatus={dmp_status} mobile={true} />
          </div>
        )}


        {/* <Button
          variant={buttonVariant}
          className="toggle"
          onClick={toggleVisibleGraph}
        >
          <ArrowWhiteIcon className={visibleGraph ? "rotated" : ""} />
        </Button> */}

        {/* {visibleGraph && <CardDashedGraph chartData={StatIdDay} budget={basic_config.full_budget || 0 + " ₽"}/>} chartData=StatIdDay */}
      </div>
    </div>
  );
};

export default memo(CompanyBubble);

// DMP Pixel Status Block

const dmpModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

function DmpPixelStatus({ campaignId, dmpStatus, mobile }) {
  const [status, setStatus] = useState(dmpStatus === null ? 'unknown' : dmpStatus ? 'found' : 'not_found');
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const pixelCode = `<!-- Programmatic.ru dmp counter --> \n<script async type='text/javascript' src='https://dmp.programmatic.ru/assets'></script> \n<!-- Programmatic.ru dmp counter -->`;

  // Обновляем статус при изменении dmpStatus из пропсов
  useEffect(() => {
    if (dmpStatus === null) {
      setStatus('unknown');
    } else if (dmpStatus === true) {
      setStatus('found');
    } else if (dmpStatus === false) {
      setStatus('not_found');
    }
  }, [dmpStatus]);

  let statusColor = '#ff9c00';
  let statusText = 'Статус: не проверен';
  let StatusIcon = HelpOutlineIcon;

  if (status === 'not_found') {
    statusColor = '#e53935';
    statusText = 'Статус: Пиксель не найден';
    StatusIcon = HighlightOffIcon;
  } else if (status === 'found') {
    statusColor = '#43a047';
    statusText = 'Статус: Пиксель найден';
    StatusIcon = CheckCircleOutlineIcon;
  }

  const handleCheck = async () => {
    if (!campaignId) {
      enqueueSnackbar("Ошибка: ID кампании не найден", { variant: "error" });
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${DOMAIN_API_HOST}/api/v1/campaigns/check-dmp?campaign_id=${campaignId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.exists) {
        setStatus('found');
        enqueueSnackbar("Пиксель найден на сайте", { variant: "success" });
        // Обновляем список кампаний для отображения актуального статуса
        dispatch(getCampaigns());
      } else {
        setStatus('not_found');
        enqueueSnackbar("Пиксель не найден на сайте", { variant: "warning" });
        // Обновляем список кампаний для отображения актуального статуса
        dispatch(getCampaigns());
      }
    } catch (error) {
      console.error('Ошибка при проверке DMP статуса:', error);
      enqueueSnackbar("Ошибка при проверке статуса пикселя", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card sx={{ display: 'flex', flexDirection: mobile ? 'column' : 'row', alignItems: mobile ? 'flex-start' : 'center', px: 2, pb: 2, pt: mobile ? 2 : 0, minWidth: 340, maxWidth: 550, boxShadow: 0, borderRadius: 2 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
        <StatusIcon style={{ color: statusColor, fontSize: 32 }} />
        <div>
          <Typography variant="body2" color="textSecondary">DMP пиксель</Typography>
          <p style={{ color: statusColor, textWrap: 'nowrap', fontWeight: 600, fontSize: 14 }}>{statusText}</p>
        </div>
      </div>
      <button variant="text" style={{ margin: mobile ? "10px 0" : "0 20px", display: "flex", alignItems: "center", gap: 4 }} onClick={() => setModalOpen(true)}>
        <InfoOutlinedIcon style={{ marginRight: 4 }} /> Инструкция
      </button>
      <Button
        style={{ textWrap: 'nowrap' }}
        variant="gradient"
        onClick={handleCheck}
        disabled={isLoading}
      >
        {isLoading ? 'Проверка...' : 'Проверить'}
      </Button>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={dmpModalStyle} style={{ width: mobile ? '90%' : '550px' }}>
          <Typography variant="h6" gutterBottom>Инструкция по установке DMP пикселя</Typography>
          <Typography variant="body1" gutterBottom>
            Разместите следующий HTML-код пикселя в пределах тега &lt;head&gt; вашего сайта:
          </Typography>
          <Box sx={{ position: 'relative', bgcolor: '#f5f5f5', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: 14, mb: 2, mt: 2 }}>
            <span
              style={{ position: 'absolute', top: 8, right: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', zIndex: 2 }}
              onClick={() => {
                navigator.clipboard.writeText(pixelCode);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              }}
              title="Скопировать код"
            >
              <ContentCopyIcon fontSize="small" style={{ marginRight: 4 }} />
              <span style={{ fontSize: 13, color: copied ? '#43a047' : '#333', fontWeight: 500 }}>
                {copied ? 'Скопировано!' : 'Копировать'}
              </span>
            </span>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: mobile ? 'break-all' : 'pretty', paddingTop: 10 }}>{pixelCode}</pre>
          </Box>
          <Typography variant="body2" color="textSecondary">
            После установки пикселя, нажмите &quot;Проверить статус&quot; для проверки корректности установки.
          </Typography>
          <Box sx={{ textAlign: 'right', mt: 2 }}>
            <Button variant="gradient" onClick={() => setModalOpen(false)}>Понятно</Button>
          </Box>
        </Box>
      </Modal>
    </Card>
  );
}
